import type { ImageLoader } from '../base-image.types';

/**
 * Standard image widths matching next/legacy/image defaults.
 * This is needed to support components that are still using
 * next/legacy/image
 * deviceSizes: [640, 750, 828, 960, 1080, 1200, 1920, 2048, 3840]
 */
export const RESPONSIVE_WIDTHS = [640, 750, 828, 960, 1080, 1200, 1920, 2048, 3840] as const;

export interface GetResponsiveAttrsParams {
  src: string;
  quality?: number | string;
  loader?: ImageLoader;
  sizes?: string;
}

export interface ResponsiveAttrs {
  srcSet: string;
  sizes: string;
}

export function getResponsiveAttrs({
  src,
  quality,
  loader,
  sizes,
}: GetResponsiveAttrsParams): ResponsiveAttrs {
  const srcSet = RESPONSIVE_WIDTHS.map((w) => {
    const url = loader ? loader({ src, width: w, quality }) : src;
    return `${url} ${w}w`;
  }).join(', ');

  return {
    srcSet,
    sizes: sizes ?? '100vw',
  };
}
